import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  filterComponent: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
    paddingTop: theme.spacing(1),
    '& .MuiAutocomplete-inputRoot': {
      height: 'fit-content',
    },
  },
  tabList: {
    width: '100%',
    paddingBottom: 'none',
    borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.neutral.main}`,
  },
  tab: {
    '& .MuiTab-wrapper': {
      borderRight: `${theme.spacing(0.125)} solid ${theme.palette.neutral.main}`,
      paddingRight: theme.spacing(1.5),
    },
    paddingRight: '0',
  },
  tabPanel: {
    padding: `${theme.spacing(3)} 0 0 0`,
  },
  applyButton: {
    width: '120px',
  },
}));

export default useStyles;
